import {Component} from '@angular/core';

@Component({
    selector: 'eocm-eocv-router',
    templateUrl: './router.component.html'
})
export class RouterComponent {}
